import axios from "axios";
import APIURL from "../../../Main/apiurl";

const getAuthToken = () => {
  const token = localStorage.getItem("user");
  return token || null;
};

const getAuthHeaders = () => {
  const token = getAuthToken();
  if (!token) return null;
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

const upload_bank_statement = async (data) => {
  try {
    const token = localStorage.getItem("user");

    const response = await axios.post(`${APIURL}/bank-reconciliation/upload`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const get_bank_statements = async (params) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        page: params?.page || 1,
        limit: params?.limit || 10,
        status: params?.status,
        bankAccountId: params?.bankAccountId,
        startDate: params?.startDate,
        endDate: params?.endDate,
      },
    };

    const response = await axios.get(`${APIURL}/bank-reconciliation/statements`, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const get_bank_statement = async (id) => {
  try {
    console.log("ayhufks", id)
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${APIURL}/bank-reconciliation/statement/${id}`, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const delete_bank_statement = async (id) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.delete(`${APIURL}/bank-reconciliation/statement/${id}`, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const auto_reconcile = async (statementId, data = {}) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/bank-reconciliation/reconcile/auto/${statementId}`, data, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const manual_reconcile = async (statementId, transactionId, data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/bank-reconciliation/reconcile/manual/${statementId}/${transactionId}`,
      data,
      config
    );

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const unreconcile_transaction = async (statementId, transactionId) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/bank-reconciliation/reconcile/unreconcile/${statementId}/${transactionId}`,
      {},
      config
    );

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const get_reconciliation_summary = async (bankAccountId, params) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        asOfDate: params?.asOfDate,
      },
    };

    const response = await axios.get(`${APIURL}/bank-reconciliation/summary/${bankAccountId}`, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const export_reconciliation_report = async (statementId) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${APIURL}/bank-reconciliation/report/${statementId}`, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const download_csv_template = async () => {
  try {
    const token = localStorage.getItem("user");
    const response = await axios.get(`${APIURL}/bank-reconciliation/template/download`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    });

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return null;
    }
    return response.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const get_csv_columns = async () => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${APIURL}/bank-reconciliation/template/columns`, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export {
  upload_bank_statement,
  get_bank_statements,
  get_bank_statement,
  delete_bank_statement,
  auto_reconcile,
  manual_reconcile,
  unreconcile_transaction,
  get_reconciliation_summary,
  export_reconciliation_report,
  download_csv_template,
  get_csv_columns,
};